/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-additional-history.reducer';

export const UserAdditionalHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userAdditionalHistoryEntity = useAppSelector(state => state.userAdditionalHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userAdditionalHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.detail.title">UserAdditionalHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.id}</dd>
          <dt>
            <span id="coffee">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.coffee">Coffee</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.coffee}</dd>
          <dt>
            <span id="tobacco">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.tobacco">Tobacco</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.tobacco}</dd>
          <dt>
            <span id="alcohol">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.alcohol">Alcohol</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.alcohol}</dd>
          <dt>
            <span id="sleepPatterns">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.sleepPatterns">Sleep Patterns</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.sleepPatterns}</dd>
          <dt>
            <span id="exercisePatterns">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.exercisePatterns">Exercise Patterns</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.exercisePatterns}</dd>
          <dt>
            <span id="seatbeltUse">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.seatbeltUse">Seatbelt Use</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.seatbeltUse}</dd>
          <dt>
            <span id="counseling">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.counseling">Counseling</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.counseling}</dd>
          <dt>
            <span id="hazardousActivities">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.hazardousActivities">Hazardous Activities</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.hazardousActivities}</dd>
          <dt>
            <span id="recreationalDrugs">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recreationalDrugs">Recreational Drugs</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recreationalDrugs}</dd>
          <dt>
            <span id="recentBreastExam">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentBreastExam">Recent Breast Exam</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentBreastExam}</dd>
          <dt>
            <span id="recentMammogram">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentMammogram">Recent Mammogram</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentMammogram}</dd>
          <dt>
            <span id="recentGynocologicalExam">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentGynocologicalExam">Recent Gynocological Exam</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentGynocologicalExam}</dd>
          <dt>
            <span id="recentRectalExam">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentRectalExam">Recent Rectal Exam</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentRectalExam}</dd>
          <dt>
            <span id="recentProstateExam">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentProstateExam">Recent Prostate Exam</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentProstateExam}</dd>
          <dt>
            <span id="recentPhysicalExam">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentPhysicalExam">Recent Physical Exam</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentPhysicalExam}</dd>
          <dt>
            <span id="recentSigmoidoscopyColonoscopy">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentSigmoidoscopyColonoscopy">
                Recent Sigmoidoscopy Colonoscopy
              </Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentSigmoidoscopyColonoscopy}</dd>
          <dt>
            <span id="recentEcg">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentEcg">Recent Ecg</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentEcg}</dd>
          <dt>
            <span id="recentCardiacEcho">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentCardiacEcho">Recent Cardiac Echo</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentCardiacEcho}</dd>
          <dt>
            <span id="recentRetinal">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentRetinal">Recent Retinal</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentRetinal}</dd>
          <dt>
            <span id="recentFluvax">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentFluvax">Recent Fluvax</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentFluvax}</dd>
          <dt>
            <span id="recentPneuvax">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentPneuvax">Recent Pneuvax</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentPneuvax}</dd>
          <dt>
            <span id="recentLdl">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentLdl">Recent Ldl</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentLdl}</dd>
          <dt>
            <span id="recentHemoglobin">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentHemoglobin">Recent Hemoglobin</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentHemoglobin}</dd>
          <dt>
            <span id="recentPsa">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentPsa">Recent Psa</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentPsa}</dd>
          <dt>
            <span id="recentExamResults">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.recentExamResults">Recent Exam Results</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.recentExamResults}</dd>
          <dt>
            <span id="historyMother">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.historyMother">History Mother</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.historyMother}</dd>
          <dt>
            <span id="dcMother">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.dcMother">Dc Mother</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.dcMother}</dd>
          <dt>
            <span id="historyFather">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.historyFather">History Father</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.historyFather}</dd>
          <dt>
            <span id="dcFather">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.dcFather">Dc Father</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.dcFather}</dd>
          <dt>
            <span id="historySiblings">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.historySiblings">History Siblings</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.historySiblings}</dd>
          <dt>
            <span id="dcSiblings">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.dcSiblings">Dc Siblings</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.dcSiblings}</dd>
          <dt>
            <span id="historyOffspring">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.historyOffspring">History Offspring</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.historyOffspring}</dd>
          <dt>
            <span id="dcOffspring">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.dcOffspring">Dc Offspring</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.dcOffspring}</dd>
          <dt>
            <span id="historySpouse">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.historySpouse">History Spouse</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.historySpouse}</dd>
          <dt>
            <span id="dcSpouse">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.dcSpouse">Dc Spouse</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.dcSpouse}</dd>
          <dt>
            <span id="relativesCancer">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesCancer">Relatives Cancer</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.relativesCancer}</dd>
          <dt>
            <span id="relativesTuberculosis">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesTuberculosis">Relatives Tuberculosis</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.relativesTuberculosis}</dd>
          <dt>
            <span id="relativesDiabetes">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesDiabetes">Relatives Diabetes</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.relativesDiabetes}</dd>
          <dt>
            <span id="relativesHighBloodPressure">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesHighBloodPressure">
                Relatives High Blood Pressure
              </Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.relativesHighBloodPressure}</dd>
          <dt>
            <span id="relativesHeartProblems">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesHeartProblems">Relatives Heart Problems</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.relativesHeartProblems}</dd>
          <dt>
            <span id="relativesStroke">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesStroke">Relatives Stroke</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.relativesStroke}</dd>
          <dt>
            <span id="relativesEpilepsy">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesEpilepsy">Relatives Epilepsy</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.relativesEpilepsy}</dd>
          <dt>
            <span id="relativesMentalIllness">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesMentalIllness">Relatives Mental Illness</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.relativesMentalIllness}</dd>
          <dt>
            <span id="relativesSuicide">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.relativesSuicide">Relatives Suicide</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.relativesSuicide}</dd>
          <dt>
            <span id="cataractSurgery">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.cataractSurgery">Cataract Surgery</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.cataractSurgery}</dd>
          <dt>
            <span id="tonsillectomy">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.tonsillectomy">Tonsillectomy</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.tonsillectomy}</dd>
          <dt>
            <span id="cholecystestomy">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.cholecystestomy">Cholecystestomy</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.cholecystestomy}</dd>
          <dt>
            <span id="heartSurgery">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.heartSurgery">Heart Surgery</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.heartSurgery}</dd>
          <dt>
            <span id="hysterectomy">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.hysterectomy">Hysterectomy</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.hysterectomy}</dd>
          <dt>
            <span id="herniaRepair">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.herniaRepair">Hernia Repair</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.herniaRepair}</dd>
          <dt>
            <span id="hipReplacement">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.hipReplacement">Hip Replacement</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.hipReplacement}</dd>
          <dt>
            <span id="kneeReplacement">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.kneeReplacement">Knee Replacement</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.kneeReplacement}</dd>
          <dt>
            <span id="appendectomy">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.appendectomy">Appendectomy</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.appendectomy}</dd>
          <dt>
            <span id="tmDate">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.tmDate">Tm Date</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.tmDate}</dd>
          <dt>
            <span id="name1">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.name1">Name 1</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.name1}</dd>
          <dt>
            <span id="value1">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.value1">Value 1</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.value1}</dd>
          <dt>
            <span id="name2">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.name2">Name 2</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.name2}</dd>
          <dt>
            <span id="value2">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.value2">Value 2</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.value2}</dd>
          <dt>
            <span id="additionalHistory">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.additionalHistory">Additional History</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.additionalHistory}</dd>
          <dt>
            <span id="exams">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.exams">Exams</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.exams}</dd>
          <dt>
            <span id="usertext11">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext11">Usertext 11</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext11}</dd>
          <dt>
            <span id="usertext12">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext12">Usertext 12</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext12}</dd>
          <dt>
            <span id="usertext13">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext13">Usertext 13</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext13}</dd>
          <dt>
            <span id="usertext14">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext14">Usertext 14</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext14}</dd>
          <dt>
            <span id="usertext15">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext15">Usertext 15</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext15}</dd>
          <dt>
            <span id="usertext16">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext16">Usertext 16</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext16}</dd>
          <dt>
            <span id="usertext17">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext17">Usertext 17</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext17}</dd>
          <dt>
            <span id="usertext18">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext18">Usertext 18</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext18}</dd>
          <dt>
            <span id="usertext19">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext19">Usertext 19</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext19}</dd>
          <dt>
            <span id="usertext20">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext20">Usertext 20</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext20}</dd>
          <dt>
            <span id="usertext21">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext21">Usertext 21</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext21}</dd>
          <dt>
            <span id="usertext22">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext22">Usertext 22</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext22}</dd>
          <dt>
            <span id="usertext23">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext23">Usertext 23</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext23}</dd>
          <dt>
            <span id="usertext24">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext24">Usertext 24</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext24}</dd>
          <dt>
            <span id="usertext25">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext25">Usertext 25</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext25}</dd>
          <dt>
            <span id="usertext26">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext26">Usertext 26</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext26}</dd>
          <dt>
            <span id="usertext27">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext27">Usertext 27</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext27}</dd>
          <dt>
            <span id="usertext28">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext28">Usertext 28</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext28}</dd>
          <dt>
            <span id="usertext29">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext29">Usertext 29</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext29}</dd>
          <dt>
            <span id="usertext30">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.usertext30">Usertext 30</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.usertext30}</dd>
          <dt>
            <span id="userdate11">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userdate11">Userdate 11</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.userdate11}</dd>
          <dt>
            <span id="userdate12">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userdate12">Userdate 12</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.userdate12}</dd>
          <dt>
            <span id="userdate13">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userdate13">Userdate 13</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.userdate13}</dd>
          <dt>
            <span id="userdate14">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userdate14">Userdate 14</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.userdate14}</dd>
          <dt>
            <span id="userdate15">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userdate15">Userdate 15</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.userdate15}</dd>
          <dt>
            <span id="userarea11">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userarea11">Userarea 11</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.userarea11}</dd>
          <dt>
            <span id="userarea12">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.userarea12">Userarea 12</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.userarea12}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.timestampentry}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{userAdditionalHistoryEntity.microSec}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.consultant">Consultant</Translate>
          </dt>
          <dd>{userAdditionalHistoryEntity.consultant ? userAdditionalHistoryEntity.consultant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.userAdditionalHistory.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{userAdditionalHistoryEntity.glucoUser ? userAdditionalHistoryEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-additional-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-additional-history/${userAdditionalHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserAdditionalHistoryDetail;
